<div id="les-moins-form" class="px-4 mb-4">
  <form class="d-flex align-items-end justify-content-between w-50">
    <p-input
      [formControl]="this.drawbacksForm.controls.drawback"
      id="drawback"
      name="drawback"
      label="Liste des moins (12 max.)"
      [disabled]="isMaxDrawbacksReached"
      [maxLength]="50"
      [showCounter]="true"
      class="flex-grow-1 me-2"
    ></p-input>

    <p-button
      label="Ajouter"
      level="primary"
      type="button"
      [disabled]="isAddDrawbackDisabled"
      [title]="addDrawbackTitle"
      (click)="addDrawback()"
    ></p-button>
  </form>

  <div class="row pt-3">
    <span
      *ngFor="let drawback of newDrawbacks.items"
      class="col-3 mb-3 d-block overflow-hidden"
    >
      <div class="d-flex">
        <span>{{ drawback }}</span>
        <i-feather
          name="x-circle"
          class="text-danger ms-1"
          (click)="deleteDrawback(drawback)"
        ></i-feather>
      </div>
    </span>
  </div>
</div>
